<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner">
    <div class="container">
        <div class="goBackBtn text-end px-5">
           
        </div>
        <div class="inner-title text-center">
            <h3>الشروط والأحكام</h3>
        </div>
    </div>
</div>

    <div class="terms-container">
        <!-- سياسة الاسترجاع -->
        <div class="section-card" id="return-policy">
            <div class="section-title">سياسة الاسترجاع</div>
            <div class="section-content">
                <p>التطبيق لا يستطيع ان يتدخل في عملية الاسترجاع لان التطبيق هو عبارة عن موقع او بوابة للمطعم او الماركت مباشرا دون اي تدخل من تطبيق وصلة و في حال حدوث مشكلة في الطلب يتم التواصل مع المطعم او الماركت بشكل مباشر لحل المشكلة لديكم</p>
            </div>
        </div>
        
        <!-- التصديق على الاتفاق -->
        <div class="section-card" id="agreement">
            <div class="section-title">التصديق على الاتفاق</div>
            <div class="section-content">
                <p>للاشتراك في موقع وصلة، يجب أولاً تعبئة نموذج التسجيل والموافقة على الالتزام ببنود اتفاقية مستخدم وصلة. وبمجرد تعبئة نموذج التسجيل واعتماده، أو الحصول على أي من الخدمات، أو طلب أي وجبة من خلال هذا النظام، فإنك توافق على الالتزام باتفاقية المستخدم الخاصة بـ وصلة.</p>
                <p>أنت مسؤول عن اتخاذ جميع الخطوات اللازمة التي تمكّنك من الوصول إلى الموقع. كما أنك مسؤول عن التأكد من أن جميع الأشخاص الذين يستخدمون الموقع عبر اتصالك بالإنترنت على علم بهذه الشروط ويلتزمون بها.</p>
                <p>إن قيامك بعرض أو استخدام أو الوصول أو التصفح أو إرسال أي محتوى أو مواد عبر الموقع يُعد موافقة منك على هذه الشروط باعتبارها اتفاقاً قانونياً ملزماً بينك وبين وصلة، وذلك دون أي قيود أو استثناءات.</p>
                <p>ويُقصد بكلمة "أنت" أو "المستخدم" أي شخص أو جهة يقوم بعرض أو استخدام أو الوصول أو التصفح أو إرسال أي محتوى أو مادة عبر الموقع.</p>
                
                <div class="highlight-box">
                    <p>إذا كنت لا توافق على هذه الشروط، فلا يحق لك استخدام الموقع.</p>
                </div>
                
                <p>وتحتفظ وصلة بحقها في تعديل شروط الاستخدام في أي وقت دون إشعار مسبق. وتوافق أنت على أن كل زيارة تقوم بها للموقع ستكون خاضعة للشروط السارية في وقت الزيارة، وأن استمرارك في استخدام الموقع سواء الآن أو بعد أي تعديلات على الشروط يُعد تأكيداً على أنك قرأت وفهمت ووافقت على الالتزام بهذه التعديلات.</p>
                <p>تنطبق الشروط والأحكام على موقع وصلة وعلى التطبيقات المرتبطة به على منصات iPhone وiPad وAndroid والموقع المخصص للهواتف المحمولة.</p>
            </div>
        </div>
        
        <!-- وصف الخدمة -->
        <div class="section-card" id="service-description">
            <div class="section-title">وصف الخدمة</div>
            <div class="section-content">
                <p>يتيح وصلة لأعضائه الذين وافقوا على الاتفاقية إمكانية الطلب من المطاعم والمتاجر عبر الإنترنت. ويقوم وصلة بتوفير وسيلة تُمكّنك من إيصال طلباتك إلى مزوّدي خدمة التوصيل المعروضين على هذا الموقع.</p>
                <p>الهدف من هذا الموقع هو تقديم خدمة بسيطة ومريحة للمستخدمين، من خلال ربطهم بالمطاعم الموجودة في منطقتهم والتي توفر خدمات الوجبات الجاهزة، والسوبر ماركت، والخضروات والفواكه، وغيرها. وتتيح القوائم التفاعلية للعملاء إنشاء طلباتهم وإرسالها بضغطة زر واحدة.</p>
                <p>لقد أنشأنا هذا الموقع ليكون بمثابة سوق إلكتروني يقدم خدمات الطعام والمنتجات المنزلية. ويُعد وصلة خدمة تجارية مخصّصة لتوصيل الطعام واحتياجات المنزل عبر الإنترنت.</p>
                
                <div class="important-note">
                    <p><strong>هام:</strong> لا يقوم وصلة ببيع أو التدخل في تصنيع أي طعام يُعد داخل المطاعم. وما يقدّمه هذا السوق الإلكتروني للمستخدمين هو فقط إتاحة إمكانية البحث عن المطاعم المحلية التي توفر خدمة التوصيل إلى العناوين الخاصة بهم، وتمكينهم من طلب هذا الطعام عبر الموقع.</p>
                </div>
                
                <p>وتلتزم المطاعم بالامتثال للقوانين والأنظمة والمعايير المحلية المتعلقة بإعداد الطعام وبيعه وتسويقه وسلامته.</p>
                <p>ومع ذلك، يجب أن يدرك المستخدمون أن وصلة لا يتحقق بشكل مستقل من صحة المعلومات أو الادعاءات أو المنتجات التي تقدمها المطاعم، بما في ذلك المكونات أو جودة المنتجات أو مدى امتثال المطعم للقوانين واللوائح المعمول بها.</p>
                <p>ويجب على المشتريين التأكد بأنفسهم من جودة ومصداقية المطاعم، ومن التزامها بالقوانين، وذلك بناءً على المعلومات المتوفرة على الموقع أو من خلال التواصل المباشر مع المطاعم.</p>
                <p>كما أن وصلة لا يضمن جودة أي طعام أو توافقه مع القوانين المطبقة، ولا يضمن التطابق التام بين القائمة المعروضة على الموقع وبين ما يتم تقديمه بالفعل للمستخدمين.</p>
                
                <div class="warning-box">
                    <p><strong>تنبيه:</strong> وقد تقدم بعض المطاعم معلومات تفيد بأن الطعام يتم إعداده وفق معايير خاصة، مثل كونه "عضوياً" أو "ماكروبيوتيك"، أو مطابقاً لمعايير خاصة بالحساسية مثل "خالٍ من المكسرات" أو "خالٍ من الجلوتين" أو "خالٍ من اللاكتوز". ولكن وصلة لا يقوم بالتحقق من صحة هذه الادعاءات.</p>
                </div>
                
                <p>لا يتحمل وصلة أي مسؤولية عن الطعام أو الخدمات التي تقدمها المطاعم في حال كانت غير صحية، أو تسببت في إصابة، أو لم تكن مقبولة للمشتريين، أو لم تحقق توقعاتهم بأي شكل من الأشكال.</p>
                <p>ويتحمل المشتري المسؤولية الكاملة عن التحقق من صحة عنوان التوصيل، ولا يتحمل وصلة أي مسؤولية عن الأخطاء الناتجة عن إدخال عناوين غير صحيحة.</p>
                <p>وتقع مسؤولية إعداد الطعام وتوصيله بالكامل على عاتق المطعم الذي يقبل الطلب.</p>
                <p>يُرجى العلم بأن المطعم سيبذل كل ما بوسعه للالتزام بالوقت المحدد للتوصيل، إلا أن أوقات التوصيل قد تتأثر بعوامل خارجة عن إرادتهم، وبالتالي قد لا يمكن ضمانها. وسنقوم بإبلاغك في حال علمنا بحدوث تأخير غير متوقع.</p>
            </div>
        </div>
        
        <!-- كيفية إصدار طلب وكيفية معالجته -->
        <div class="section-card" id="order-process">
            <div class="section-title">كيفية إصدار طلب وكيفية معالجته</div>
            <div class="section-content">
                <p>بمجرد تحديد طلبك من قائمة مطعم التوصيل الذي اخترته ، ستتاح لك الفرصة لتقديم طلبك بالنقر فوق الزر "تأكيد الطلب". يرجى ملاحظة أنه من المهم أن تتحقق من المعلومات التي أدخلتها وتصحيح أي أخطاء قبل النقر فوق الزر "تأكيد الطلب" لأنه بمجرد النقر فوق أخطاء الإدخال هذه لا يمكن تصحيحها. عند استلام طلبك ، سنبدأ في معالجة طلبك وسنرسل رسالة في الصفحة الأخيرة تفيد بأنه تم استلام طلبك وإرساله بنجاح إلى المطعم.</p>
            </div>
        </div>
        
        <!-- إلغاء الطلبات -->
        <div class="section-card" id="order-cancellation">
            <div class="section-title">إلغاء الطلبات</div>
            <div class="section-content">
                <div class="warning-box">
                    <p>لا يحق للعميل إلغاء الطلب بعد الضغط على زر "تأكيد الطلب" للطلب في تطبيقنا.</p>
                </div>
                
                <p>بينما يتم بذل كل جهد ممكن لضمان الحفاظ على الأسعار والأوصاف الدقيقة ، يحق لنا إلغاء أي طلب مبني على معلومات غير دقيقة. قد يتم إلغاء الطلب لاحقا من قبل المطعم بعد تلقيك تأكيدا بأنه قد تم إرساله إلى المطعم.</p>
                <p>يحتفظ تطبيقنا والمطاعم الشريكة بالحق في إلغاء أي طلب قبل أو بعد القبول وسنخطرك على الفور بأي إلغاء من هذا القبيل سيحتفظ سجلك بطلباتك الناجحة والمرفوضة وفي حالة فشل الدفع عبر الإنترنت ، سيتم إرجاع المبلغ المسترد إلى حسابك المحترم في غضون 7-14 يوما وفقا للبنك الذي تتعامل معه.</p>
            </div>
        </div>
        
        <!-- نظام العضوية لتطبيقنا -->
        <div class="section-card" id="membership">
            <div class="section-title">نظام العضوية لتطبيقنا</div>
            <div class="section-content">
                <p>يمتلك كل عضو في وصلة "اسم مستخدم" و"كلمة مرور" يقوم بتحديدهما بنفسه. ويُعد اسم المستخدم خاصاً بكل عضو ولا يمكن منحه لعضوين مختلفين. أما كلمة المرور فهي معلومة للعضو فقط، ويمكنه تغييرها في أي وقت.</p>
                <p>ويقع على العضو وحده مسؤولية اختيار كلمة مرور آمنة وحمايتها. ولا يتحمل وصلة أي مسؤولية عن المشكلات التي قد تنشأ نتيجة استخدام كلمة المرور.</p>
                <p>يقوم وصلة بإرسال إشعارات عبر الهاتف المحمول لإبلاغ المستخدم بالعروض المتاحة في منطقته والتي قد يستفيد منها. ولا يقوم وصلة بمشاركة معلومات المستخدم مع أي جهات خارجية، باستثناء رقم الهاتف الذي قد تتم مشاركته مع المطعم المنفذ للطلب لضمان سرعة ودقة التوصيل.</p>
                <p>ولكي يتمكن العضو من الوصول إلى الخدمات التي تتطلب عضوية في وصلة ، يجب عليه إدخال اسم المستخدم وكلمة المرور. وتُسمى هذه العملية بـ"تسجيل الدخول" إلى وصلة.</p>
                
                <div class="important-note">
                    <p><strong>التزامات المستخدم:</strong></p>
                    <ul>
                        <li>باستخدامك لهذا الموقع، فإنك تقرّ بأن جميع المعلومات الشخصية التي تقدمها صحيحة ودقيقة وحديثة وكاملة من جميع الجوانب</li>
                        <li>يجب إبلاغنا فوراً بأي تعديلات على بياناتك الشخصية</li>
                        <li>يجب عدم انتحال شخصية أي فرد أو جهة</li>
                        <li>لا يُسمح بتسجيل أكثر من عضوية واحدة لنفس الشخص</li>
                        <li>أي مخالفة لهذا البند قد تؤدي إلى إلغاء عضويتك فوراً</li>
                    </ul>
                </div>
                
                <div class="warning-box">
                    <p><strong>استخدامات محظورة للموقع:</strong></p>
                    <ul>
                        <li>نشر أو توزيع أي مواد غير قانونية، أو تشهيرية، أو مسيئة، أو تهديدية، أو ضارة، أو فاحشة</li>
                        <li>إرسال أو تمرير مواد تشكل جريمة جنائية أو تنطوي على مسؤولية مدنية</li>
                        <li>التدخل في استخدام الآخرين للموقع أو تعطيل تجربتهم</li>
                        <li>الإضرار بالموقع أو تعطيل عمله أو محاولة الوصول غير المصرح به إليه</li>
                    </ul>
                </div>
            </div>
        </div>
        
        <!-- مسؤوليات العضو -->
        <div class="section-card" id="member-responsibilities">
            <div class="section-title">مسؤوليات العضو</div>
            <div class="section-content">
                <p>عند استخدام خدمات وصلة، يوافق العضو ويتعهد بالتالي:</p>
                
                <div class="sub-section">
                    <h4>صحة المعلومات</h4>
                    <ul>
                        <li>أن جميع المعلومات الموجودة في نموذج التسجيل صحيحة</li>
                        <li>في حال كانت هذه المعلومات مطلوبة، يكون العضو مسؤولاً وحده عن أي خسائر ناتجة عن معلومات غير صحيحة أو غير مكتملة (مثل نسيان كلمة المرور)</li>
                        <li>وفي هذه الحالات قد يتم إنهاء عضويته</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>المحتوى الذي ينشره العضو</h4>
                    <ul>
                        <li>العضو مسؤول بشكل كامل عن أي أفكار أو آراء أو تصريحات يقدمها أثناء استخدام خدمات وصلة وكذلك عن جميع الملفات التي يقوم برفعها إلى وصلة وأي معلومات شخصية يقوم بإرسالها</li>
                        <li>ولا تتحمل وصلة أي مسؤولية عن هذه الملفات أو المحتويات</li>
                        <li>يلتزم العضو بعدم الوصول إلى أي خدمات يقدمها وصلة بطريقة غير مخوّلة، أو باستخدام أي طريقة غير تلك المحددة من قبل وصلة</li>
                        <li>يلتزم بعدم تغيير أي جزء من البرمجيات أو استخدام نسخ معدّلة منها</li>
                        <li>ويتعهد بتعويض وصلة عن أي خسائر مادية أو معنوية تنتج عن عدم الالتزام بما سبق</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>الأمن والالتزام بالقانون</h4>
                    <ul>
                        <li>لا يتحمل وصلة أي مسؤولية عن أي أضرار تنتج عن وصول أشخاص غير مخوّلين إلى بيانات أي عضو</li>
                        <li>يلتزم العضو بعدم إرسال أي رسائل تهديدية، أو غير أخلاقية، أو عنصرية، أو مخالفة لقوانين جمهورية مصر العربية أو الاتفاقيات الدولية</li>
                        <li>يجب ألا تكون العناوين أو الألقاب أو أسماء المستخدمين مخالفة للآداب العامة أو القانون</li>
                        <li>يلتزم العضو بعدم مضايقة أو تهديد المستخدمين الآخرين أو موظفي الدعم</li>
                        <li>يلتزم بعدم القيام بأي نشاط يؤثر على قدرة المستخدمين الآخرين في الاستفادة من الخدمات</li>
                        <li>يمنع نشر أو طباعة أو توزيع أي مواد غير أخلاقية أو غير قانونية قد تسيء إلى الأفراد أو المؤسسات</li>
                        <li>يمنع الإعلان أو بيع أو عرض بيع أي منتجات أو خدمات، أو المشاركة في أنشطة مثل الاستبيانات أو المسابقات أو الرسائل المتسلسلة</li>
                        <li>يمنع إرسال أي معلومات أو برامج قد تضر بأجهزة المستخدمين أو برامجهم</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>الاستخدام الشخصي وتحمل المخاطر</h4>
                    <ul>
                        <li>جميع الملفات أو المحتويات التي يحصل عليها المستخدم من خلال خدمات وصلة تم الحصول عليها بموافقته، ومن ثم فهو المسؤول الوحيد عن أي أضرار أو فقدان بيانات أو أي خسائر تلحق بجهازه نتيجة لذلك</li>
                        <li>لا يحق للمستخدم المطالبة بأي تعويض عن أي خسائر ناتجة عن استخدام الخدمة</li>
                        <li>يمنع استخدام خدمات وصلة لأي غرض تجاري أو إعلاني دون موافقة مسبقة من وصلة</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>إشراف النظام</h4>
                    <ul>
                        <li>يحق لـ وصلة مراقبة النظام في أي وقت أو بشكل مستمر</li>
                        <li>ويجوز لـ وصلة استخدام نظامه لأغراض تجارية</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>الأفعال المحظورة</h4>
                    <p>يلتزم العضو بعدم القيام بما يلي:</p>
                    <ul>
                        <li>إرسال أي معلومات أو رسائل محظورة قانونياً مثل الرسائل المتسلسلة أو البرمجيات الضارة</li>
                        <li>تسجيل أو إساءة استخدام المعلومات الشخصية الخاصة بالآخرين</li>
                        <li>يتحمل العضو وحده مسؤولية جميع الأفعال التي تتم باستخدام "اسم المستخدم" الخاص به</li>
                        <li>يجب على العملاء دفع رسوم الخدمة المحددة مسبقاً عند تسليم المنتجات، وإلا فلن يتم تسليم الطلب</li>
                        <li>عدم استخدام حساب أو تسجيل لطرف ثالث دون موافقته الصريحة</li>
                        <li>عدم استخدام الموقع لأغراض غير قانونية</li>
                        <li>عدم ارتكاب أي انتهاك للموقع أو محتواه</li>
                        <li>عدم استخدام الموقع للقيام بأنشطة تجارية خارج إطار الخدمات المصرح بها من وصلة</li>
                        <li>عدم نسخ أي محتوى (مثل قوائم المطاعم أو تقييمات الجهات الثالثة) بغرض إعادة نشره</li>
                        <li>عدم كتابة تقييمات أو مقالات لأغراض تجارية أو لأهداف لا تتوافق مع روح الموقع</li>
                        <li>عدم محاولة الوصول غير المصرح به إلى أنظمة أخرى من خلال الموقع</li>
                        <li>عدم التدخل في استخدام الآخرين للموقع</li>
                        <li>عدم رفع أو إرسال فيروسات أو ملفات ضارة</li>
                        <li>عدم تعطيل أو إلحاق الضرر بأمن الموقع أو أي خدمات أو خوادم أو شبكات مرتبطة به، بما في ذلك شبكات شركائنا من المطاعم</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>استخدام القُصّر للموقع</h4>
                    <ul>
                        <li>يجب على المستخدمين القُصّر (عادة من هم دون 18 عاماً) الحصول على موافقة ولي الأمر، وأن يستخدموا الموقع تحت إشراف مباشر منه</li>
                        <li>إذا كنت قاصراً، يجب على ولي أمرك قراءة هذه الاتفاقية والموافقة عليها قبل استخدامك للموقع</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>بطاقات الدفع</h4>
                    <ul>
                        <li>يجب أن تكون بطاقات الائتمان أو الخصم المستخدمة في عملية الدفع عبر بوابة الدفع الإلكتروني في تطبيق أو موقع وصلة مملوكة للمستخدم نفسه</li>
                        <li>وفي حال كانت البطاقة لا تخص المستخدم، يجب الحصول على إذن قانوني من صاحب البطاقة لإجراء العملية</li>
                    </ul>
                </div>
            </div>
        </div>
        
        <!-- مواد الزائر وسلوكه -->
        <div class="section-card" id="visitor-content">
            <div class="section-title">مواد الزائر وسلوكه</div>
            <div class="section-content">
                <p>باستثناء المعلومات الشخصية القابلة للتعريف، والتي تخضع لسياسة الخصوصية الخاصة بـ وصلة، فإن أي مواد تقوم بإرسالها أو نشرها على هذا الموقع ستُعتبر غير سرية وغير مملوكة. ولا يتحمل وصلة أي التزام تجاه هذه المواد، ويحق لـ وصلة ولأي جهة يختارها نسخ هذه المواد أو الكشف عنها أو توزيعها أو دمجها أو استخدامها بأي شكل ولأي غرض، سواء كان تجارياً أو غير تجاري، بما في ذلك جميع البيانات والصور والأصوات والنصوص وغيرها مما تتضمنه تلك المواد.</p>
                
                <div class="warning-box">
                    <p><strong>يحظر عليك نشر أو تحميل أو إرسال أي مواد إلى أو من هذا الموقع تتضمن:</strong></p>
                    <ul>
                        <li>ما يخالف أي قانون محلي أو وطني أو دولي ساري المفعول</li>
                        <li>مواد غير قانونية أو احتيالية</li>
                        <li>إعلانات غير مصرح بها</li>
                        <li>فيروسات أو برامج مضرة بأي شكل</li>
                    </ul>
                    <p>كما يُحظر إساءة استخدام الموقع بأي طريقة، بما في ذلك محاولة اختراقه.</p>
                </div>
                
                <div class="sub-section">
                    <h4>التعليقات والملاحظات</h4>
                    <p>يجب ألا تتضمن التعليقات أو الملاحظات التي ترسلها عبر الموقع أي من الأمور التالية:</p>
                    <ul>
                        <li>مواد تشهيرية أو بذيئة أو مسيئة</li>
                        <li>الترويج للعنف أو التمييز</li>
                        <li>انتهاك حقوق الملكية الفكرية لأي طرف آخر</li>
                        <li>خرق أي التزام قانوني تجاه طرف ثالث (مثل واجب الحفاظ على السرية)</li>
                        <li>الترويج لأي نشاط غير قانوني أو انتهاك خصوصية الآخرين</li>
                        <li>الإيحاء بأنها صادرة عنا بشكل مباشر</li>
                        <li>انتحال شخصية أي فرد أو تقديم معلومات مضللة حول هويتك أو صلتك بأي جهة</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>التعويض عن المخالفات</h4>
                    <p>الأفعال المحظورة المذكورة أعلاه ليست حصرية. وبناءً عليه، يتحمل المستخدم مسؤولية دفع جميع التكاليف والأضرار التي قد يتكبدها وصلة نتيجة خرق أي من هذه القيود.</p>
                </div>
                
                <div class="sub-section">
                    <h4>التعاون مع السلطات</h4>
                    <p>سيتعاون وصلة بشكل كامل مع أي جهة تنفيذ قانون أو أي أمر قضائي يطلب أو يوجه بالكشف عن هوية أو موقع أي شخص يقوم بنشر مواد مخالفة لأحكام الفقرة السابقة.</p>
                </div>
            </div>
        </div>
        
        <!-- الأنشطة المحظورة -->
        <div class="section-card" id="prohibited-activities">
            <div class="section-title">الأنشطة المحظورة</div>
            <div class="section-content">
                <p>لا يجوز لك الوصول إلى الموقع أو استخدامه لأي غرض غير الذي يتيحه لك وصلة. الموقع مخصص للاستخدام الشخصي فقط، ولا يجوز استخدامه في أي أنشطة تجارية إلا تلك التي تعتمدها أو توافق عليها الشركة بشكل صريح.</p>
                <p>وفي حال قيام المستخدم بأي نشاط محظور، يحق للشركة تعليق أو حظر أو إنهاء عضويته ومنعه من الوصول إلى الخدمات.</p>
                
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>نوع النشاط المحظور</th>
                                <th>أمثلة</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>أنشطة غير قانونية أو ضارة</td>
                                <td>المواد الإباحية للأطفال، الاحتيال، تداول مواد فاحشة، تجارة المخدرات، المقامرة، التحرش، البريد المزعج، انتهاك حقوق النشر</td>
                            </tr>
                            <tr>
                                <td>الاستخدامات غير المصرح بها للموقع</td>
                                <td>الإعلان دون إذن، جمع البيانات بشكل منهجي، إرسال رسائل غير مرغوبة، إنشاء روابط دون إذن</td>
                            </tr>
                            <tr>
                                <td>الاستخدامات الآلية أو التدخل التقني</td>
                                <td>استخدام سكربتات آلية، أدوات التنقيب عن البيانات، محاولة انتحال شخصية، بيع الحساب</td>
                            </tr>
                            <tr>
                                <td>محاولات اختراق أو تلاعب بالنظام</td>
                                <td>استخدام الخدمات للمنافسة، تفكيك البرمجيات، تجاوز أنظمة الحماية، مضايقة موظفي الشركة</td>
                            </tr>
                            <tr>
                                <td>أنشطة تجارية غير مصرح بها</td>
                                <td>عرض إعلانات مدفوعة، حذف إشعارات الملكية الفكرية</td>
                            </tr>
                            <tr>
                                <td>انتهاك القوانين</td>
                                <td>استخدام الموقع بطرق تتعارض مع القوانين واللوائح المطبقة</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div class="important-note">
                    <p><strong>ملاحظة:</strong> تشمل الأنشطة المحظورة أيضًا أي نشاط آخر يُشتبه في كونه خبيثاً على موقع أو تطبيقات وصلة.</p>
                </div>
            </div>
        </div>
        
        <!-- سٌلطة التطبيق -->
        <div class="section-card" id="app-authority">
            <div class="section-title">سُلطة التطبيق</div>
            <div class="section-content">
                <ul>
                    <li>يحق لـ وصلة تعليق عمل النظام مؤقتًا أو إيقافه نهائيًا في أي وقت.</li>
                    <li>لا تتحمل وصلة أي مسؤولية تجاه أعضاء الموقع أو أي طرف ثالث نتيجة تعليق النظام مؤقتًا أو إوقافه نهائيًا.</li>
                    <li>يتم عرض اسم المستخدم وكلمة المرور واعتمادهما بعد تعبئة الأجزاء المطلوبة في الطلب الذي يقدمه العملاء عبر وصلة.</li>
                    <li>يحق لـ وصلة منع العملاء الذين أتموا تعبئة جميع الأجزاء أو لديهم كلمة مرور من الحصول على كلمة مرور جديدة أو استخدام كلمات المرور الحالية لفترة غير محددة إذا رأت الشركة ذلك ضروريًا.</li>
                    <li>لا تضمن وصلة أن خدماتها ستقدم في الوقت المحدد بطريقة آمنة وكاملة، أو أن النتائج التي يتم الحصول عليها من الخدمات ستكون صحيحة وموثوقة، أو أن جودة الخدمة ستلبي توقعات المستخدمين.</li>
                    <li>تحتفظ وصلة بالحق في نسخ احتياطي وحذف جميع الملفات أو بعض الرسائل التي يقدمها الأعضاء أثناء استخدام الخدمات، وفق الفترات التي تراها مناسبة. ولا تتحمل الشركة أي مسؤولية عن عمليات النسخ الاحتياطي أو الحذف.</li>
                    <li>تمتلك وصلة حقوق الملكية وحقوق النشر الخاصة بالمعلومات، والمستندات، والبرامج، والتصاميم، والرسومات، وما إلى ذلك، سواء تم إنتاجها داخليًا أو شراؤها من الخارج.</li>
                    <li>تقتصر مبيعات وصلة على توافر قوائم الطعام الحالية لدى المطاعم المدرجة في المنصة. ولا تتحمل وصلة مسؤولية أي عنصر تم طلبه ولم يتم تسليمه من قبل المطعم بسبب عدم التوافر.</li>
                    <li>يحق لـ وصلة نشر أي معلومات، مستندات، برامج، تصاميم، رسومات، أو غيرها (مثل الرسائل، الأشعار، التقارير/الأخبار، الملفات المنشورة على لوحة الإعلانات) التي يقوم الأعضاء بإنشائها وتحميلها على النظام، أو نقلها إلى مكان آخر داخل الموقع تعتبره الشركة مناسبًا.</li>
                    <li>من الممكن أن يتم نسخ هذه المعلومات أو نشرها من قبل مستخدمين آخرين، وفي هذه الحالة لا يحق للمستخدمين المطالبة بأي حقوق ملكية أو رسوم من وصلة.</li>
                    <li>تقع مسؤولية تحديث المعلومات المتعلقة بالأسعار ومواصفات المنتجات على الشركات التي تدير المطاعم الإلكترونية ضمن وصلة.</li>
                    <li>في حالة وجود أي معلومات خاطئة تتعلق بالأسعار أو مواصفات المنتجات، يحق لـ وصلة تصحيح الخطأ عن طريق إلغاء الطلب.</li>
                    <li>قد تقوم وصلة بتحويل العضو إلى مواقع أخرى، وفي هذه الحالة يوافق العضو على أن وصلة غير مسؤولة عن محتوى هذه المواقع التي قد يصل إليها عبر موقعها.</li>
                    <li>يحق لـ وصلة إجراء أي تغييرات في تنفيذ هذا الاتفاق، وتعديل المواد الموجودة أو إضافة مواد جديدة بما يتوافق مع الاحتياجات التقنية أو التشريعات المستقبلية.</li>
                    <li>يمكن لـ وصلة تحويل الخدمات التي لا تتطلب عضوية إلى خدمات تتطلب العضوية، أو إضافة خدمات جديدة، أو تعديل بعض الخدمات جزئيًا أو كليًا، أو تحويلها إلى خدمات مدفوعة.</li>
                    <li>قد يكون الموقع غير متاح في أوقات معينة لإجراء الصيانة والتحديثات.</li>
                    <li>على الرغم من أننا سنحاول إخطار العملاء مسبقًا بأي توقف للخدمة، لا يمكن ضمان ذلك، وتحتفظ الشركة بحق تعديل أو سحب الخدمة في أي وقت.</li>
                </ul>
            </div>
        </div>
        
        <!-- إرشادات التقييمات(المراجعات) -->
        <div class="section-card" id="reviews">
            <div class="section-title">إرشادات التقييمات(المراجعات)</div>
            <div class="section-content">
                <div class="important-note">
                    <p><strong>الموافقة على التقييمات تتم بناءً على المعايير التالية:</strong></p>
                </div>
                
                <div class="sub-section">
                    <h4>الصلة بالتجربة</h4>
                    <p>يجب أن يكون لدى المراجع تجربة مباشرة مع المطعم ليتم اعتماد تقييمه.</p>
                </div>
                
                <div class="sub-section">
                    <h4>المحتوى المقبول</h4>
                    <p>ليست وصلة ملزمة بالموافقة على أي تقييم على الموقع. ومن الأسباب المحتملة لرفض التقييم:</p>
                    <ul>
                        <li><strong>اللغة المسيئة:</strong> لا يُسمح باستخدام الكلمات البذيئة، أو اللغة المسيئة، أو العنصرية، أو خطاب الكراهية في أقسامنا التفاعلية.</li>
                        <li>المحتوى غير ذي صلة أو غير مفيد.</li>
                        <li><strong>التمييز:</strong> بناءً على الدين، أو العرق، أو الجنس، أو الأصل الوطني، أو العمر، أو الحالة الاجتماعية، أو الإعاقة.</li>
                        <li>الإشارات إلى أنشطة غير قانونية أو مراجع غير مرتبطة بعادات وقيم المجتمع.</li>
                        <li><strong>تضارب المصالح:</strong> لا يُسمح للمطاعم المنافسة بنشر تقييمات سلبية. وقد يؤدي انتهاك ذلك إلى الحذف الدائم من الموقع.</li>
                        <li>ادعاءات بانتهاك قوانين الصحة.</li>
                        <li>معلومات قديمة أو غير صحيحة.</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>غير معتمدة من قبل وصلة</h4>
                    <p>التقييمات لا تُعتمد رسميًا من وصلة، ولا تمثل وجهة نظر وصلة أو الشركات التابعة لها. ولا تتحمل وصلة أي مسؤولية عن أي تقييم، أو أي مطالبات أو خسائر ناتجة عن استخدام الموقع أو المعلومات الموجودة عليه.</p>
                </div>
                
                <div class="sub-section">
                    <h4>ملكية التقييمات</h4>
                    <p>التقييمات مملوكة حصريًا لـ وصلة بشكل دائم. للشركة الحق في نسخ، تعديل، ترجمة، نقل، أو توزيع أي مواد تتعلق بالتقييمات. ولا توجد أي التزامات بدفع أي مقابل للمؤلف أو أي شخص آخر مقابل التقييمات.</p>
                </div>
            </div>
        </div>
        
        <!-- إنهاء الاتفاقية -->
        <div class="section-card" id="termination">
            <div class="section-title">إنهاء الاتفاقية</div>
            <div class="section-content">
                <p>يجوز لتطبيقنا إنهاء هذه الاتفاقية من جانب واحد في أي وقت.</p>
            </div>
        </div>
        
        <!-- قيود الاستخدام غير الشخصي وغير التجاري -->
        <div class="section-card" id="usage-restrictions">
            <div class="section-title">قيود الاستخدام غير الشخصي وغير التجاري</div>
            <div class="section-content">
                <p>أنت توافق على أن عواقب الاستخدام التجاري أو إعادة نشر محتوى أو معلومات تطبيقنا قد تؤدي إلى تعويض مالي خطير لا يمكن حسابه قد لا يكون علاجا كافيا أو مناسبا وأن تطبيقنا يحق له الحصول على تعويض زجري مؤقت ودائم لحظر هذا الاستخدام</p>
            </div>
        </div>
        
        <!-- تسليم المنتج -->
        <div class="section-card" id="product-delivery">
            <div class="section-title">تسليم المنتج</div>
            <div class="section-content">
                <div class="warning-box">
                    <p>أثناء أي تسليم منتج يتم بواسطة تطبيقنا من خلال مندوب الخاص المقدم الخدمة سواء المطعم او الماركت ، إذا لم يكن العميل متاحا في العنوان المحدد في النظام ، فلن يتم تسليم الوجبات التي طلبها العميل إلى أي مكان آخر.</p>
                </div>
                <p>في إطار هذه الحالة ، يجب على العضو قبول جميع المسؤوليات القانونية الناشئة عن طلب وجبة إلى عنوان لا يوجد فيه</p>
            </div>
        </div>
        
        <!-- إرجاع المنتج -->
        <div class="section-card" id="product-return">
            <div class="section-title">إرجاع المنتج</div>
            <div class="section-content">
                <p>يتم تطبيق شروط إرجاع المنتج التي تخص المطاعم. لا يتحمل تطبيقنا أي مسؤوليات عن النزاعات التي قد تنشأ عن شروط إرجاع المنتج التي تخص المطاعم</p>
            </div>
        </div>
        
        <!-- طرق الدفع -->
        <div class="section-card" id="payment-methods">
            <div class="section-title">طرق الدفع</div>
            <div class="section-content">
                <p>يمكن للعملاء الاختيار بين طرق الدفع المختلفة المتوفرة على المنصات ، والتي تتمثل حاليا في ما يلي: الدفع عند الاستلام وبطاقات الخصم المحلية وبطاقات الائتمان. يحتفظ تطبيقنا بالحق في توفير طرق دفع أخرى أو عدم تقديم طرق دفع معينة بعد الآن.</p>
                
                <div class="important-note">
                    <p><strong>ملاحظات هامة:</strong></p>
                    <ul>
                        <li>يختار العميل بشكل ملزم طريقة الدفع عند تقديم الطلب المعني</li>
                        <li>بشرط أن يختار العميل طريقة دفع عبر الإنترنت ، ستتم معالجة الدفع بواسطة مزود دفع خارجي عبر الإنترنت يتعاون مع تطبيقنا</li>
                        <li>لن يتم تخزين بيانات البطاقة للطلبات المستقبلية عن طريق الدفع الخارجي عبر الإنترنت</li>
                        <li>يلتزم العملاء بضمان تغطية كافية للحساب المعني أو عند استخدام بطاقة الائتمان ، لاستخدام بطاقة الائتمان فقط ضمن حد معاملات البطاقة</li>
                        <li>يجب على العميل الامتناع عن التسبب في استرداد رسوم الخصم غير المصرح به</li>
                    </ul>
                </div>
            </div>
        </div>
        
        <!-- السعر والدفع -->
        <div class="section-card" id="pricing-payment">
            <div class="section-title">السعر والدفع</div>
            <div class="section-content">
                <p>بمجرد قبول طلبك، يُمثل ذلك اتفاقًا بينك كعميل والمطعم. يتحمل المطعم المسؤولية الكاملة عن هذا الطلب.</p>
                
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>طريقة الدفع</th>
                                <th>التفاصيل</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>الدفع نقدًا</td>
                                <td>يتم الدفع مباشرة للمطعم عند التسليم لتنفيذ الطلب</td>
                            </tr>
                            <tr>
                                <td>الدفع بالبطاقات الائتمانية أو الخصم</td>
                                <td>إذا اخترت الدفع عن طريق بطاقة الائتمان أو الخصم على الموقع، فإن عملية الدفع تتم من خلال وصلة كوكيل للمطعم</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div class="sub-section">
                    <h4>رسوم التوصيل:</h4>
                    <ul>
                        <li>تُحسب رسوم التوصيل لكل طلب حسب سياسة كل مطعم على حدة</li>
                        <li>أي رسوم توصيل أو رسوم أخرى ستُعرض بوضوح في ملخص الطلب الخاص بك</li>
                    </ul>
                </div>
                
                <div class="sub-section">
                    <h4>البطاقات الائتمانية / بطاقات الخصم</h4>
                    <p>يرجى قراءة شروط الاستخدام والتنبيهات التالية بعناية قبل استخدام البطاقات:</p>
                    <ul>
                        <li>يتحمل العميل دفع أي رسوم إضافية نقدًا عند التسليم إذا فرضها المطعم نتيجة "طلب خاص" أو "طلب عام" قام به العميل</li>
                        <li>المبلغ الذي دفعته عبر البطاقة يُعاد إلى محفظة العميل على وصلة، وإذا رغب العميل في استرجاع المبلغ مباشرة على بطاقة الفيزا، يجب التواصل معنا عبر موقع وصلة، وسيتم تحويل المبلغ إلى حساب العميل عبر بوابة الدفع. قد تستغرق عملية الاسترجاع من 7 إلى 14 يوم عمل</li>
                        <li>يجب أن يكون العملاء الذين يستخدمون بطاقات الخصم / الائتمان متاحين على أرقام الاتصال الخاصة بهم</li>
                        <li>يُعوض العميل من قبل المطعم في حال واجه المطعم مشكلة نتيجة فقدان أي عنصر من الطلب (يُطبق التعويض فقط على العنصر المفقود وفقًا لسياسة المطعم الخاصة بالتعويض)</li>
                        <li>يجب أن تكون البطاقات المستخدمة لطلب المنتجات عبر بوابة الدفع على موقع أو تطبيقات وصلة مملوكة للعميل نفسه، وإلا يجب الحصول على إذن قانوني من صاحب البطاقة لإتمام العملية</li>
                        <li>العميل يتحمل كامل المسؤولية عن الطلب باستخدام بطاقة الخصم / الائتمان بعد قراءة جميع الشروط والأحكام بعناية</li>
                    </ul>
                </div>
            </div>
        </div>
        
        <!-- القانون الحاكم والمختص -->
        <div class="section-card" id="governing-law">
            <div class="section-title">القانون الحاكم والمختص</div>
            <div class="section-content">
                <p>تخضع شروط الموقع الإلكتروني هذه وتفسر وفقا للقانون. تخضع النزاعات الناشئة فيما يتعلق بشروط الموقع الإلكتروني هذه (بما في ذلك النزاعات غير التعاقدية) للاختصاص القضائي الحصري لشروط وأحكام المحكمة</p>
            </div>
        </div>
        
        <!-- انفاذ -->
        <div class="section-card" id="enforcement">
            <div class="section-title">انفاذ</div>
            <div class="section-content">
                <p>إذا تم اعتبار أي جزء من شروط الاستخدام هذه غير قانوني أو باطل أو غير قابل للتنفيذ لأي سبب من الأسباب ، اعتبار هذا الحكم قابلا للفصل عن شروط الاستخدام هذه ولن يؤثر على صلاحية وقابلية تنفيذ أي من الأحكام المتبقية من شروط الاستخدام هذه. لا يجوز تفسير أي تنازل من جانبنا على أنه تنازل عن أي خرق سابق أو لاحق لأي حكم</p>
            </div>
        </div>
        
        <!-- ترخيص -->
        <div class="section-card" id="license">
            <div class="section-title">ترخيص</div>
            <div class="section-content">
                <p>تمنحك وصلة الإذن (الذي يمكن سحبه في أي وقت ولأي سبب أو بدون سبب) لعرض الموقع وتحميل صفحات فردية منه، أو إرسالها عبر البريد الإلكتروني، أو مشاركتها عبر الشبكات الاجتماعية، أو طباعتها، وذلك وفقًا لشروط الاستخدام هذه وللاستخدام الشخصي غير التجاري فقط، بشرط ألا تقوم بإزالة أي علامة تجارية أو حقوق نشر أو أي إشعار آخر موجود على هذه الصفحات. لا يُسمح بأي استخدام آخر.</p>
                
                <div class="warning-box">
                    <p><strong>على سبيل المثال، لا يجوز لك:</strong></p>
                    <ul>
                        <li>دمج المعلومات أو المحتوى أو أي مادة أخرى في أي قاعدة بيانات، أو تجميع، أو أرشيف، أو ذاكرة تخزين مؤقت</li>
                        <li>تعديل أو نسخ أو توزيع أو إعادة نشر أو نقل أو عرض أو أداء أو استنساخ أو نشر أو إعادة استخدام أو إعادة بيع أو ترخيص أو إنشاء أعمال مشتقة من أي معلومات، محتوى، مواد، برامج، منتجات أو خدمات تم الحصول عليها من الموقع، إلا بما هو محدد أعلاه</li>
                        <li>إلا إذا كان هناك إذن محدد من وصلة، لا يجوز لك إنشاء روابط مباشرة عميقة (deep-link) إلى الموقع لأي غرض، أو الوصول إلى الموقع يدويًا أو باستخدام أي روبوت، عنكبوت (spider)، متصفح ويب آلي، برنامج استخراج، عملية أو جهاز آلي لنسخ أو مراقبة أي جزء من الموقع أو أي معلومات أو محتوى أو مادة فيه</li>
                    </ul>
                </div>
                
                <p>تحتفظ وصلة بجميع حقوقها القانونية والنظامية ضد أي شخص أو كيان ينتهك هذا البند. لا يجوز لك ربط أو تأطير أي صفحة من صفحات الموقع أو أي محتوى موجود فيه، كليًا أو جزئيًا، دون الحصول على موافقة كتابية مسبقة من وصلة.</p>
                <p>يمكنك أن تصبح "معجبًا" بالموقع أو مشاركة روابط للموقع عبر تكنولوجيا الشبكات الاجتماعية المشار إليها في الموقع.</p>
                <p>أي حقوق لم تُمنح صراحةً هنا، فهي محفوظة لـ وصلة.</p>
            </div>
        </div>
        
        <!-- حقوق الملكية الفكرية -->
        <div class="section-card" id="intellectual-property">
            <div class="section-title">حقوق الملكية الفكرية</div>
            <div class="section-content">
                <p>المحتوى الموجود على الموقع الإلكتروني ("محتوى وصلة") والعلامات التجارية، علامات الخدمة والشعارات الموجودة فيه ("العلامات") مملوكة أو مرخصة لشركة وصلة، وهي تخضع لحقوق الطبع والنشر وغيرها من حقوق الملكية الفكرية وفقًا لقوانين دولة الكويت والاتفاقيات الدولية.</p>
                <p>يشمل محتوى وصلة، دون حصر، جميع الشيفرات المصدرية، قواعد البيانات، الوظائف، البرمجيات، تصميمات الموقع، الصوتيات، الفيديو، النصوص، الصور الفوتوغرافية والرسوميات. جميع الرسوميات، الشعارات، التصميمات، رؤوس الصفحات، أيقونات الأزرار، السكريبتات وأسماء الخدمات الخاصة بـ وصلة هي علامات تجارية مسجلة، أو علامات تجارية عرفية، أو تصميمات تجارية.</p>
                
                <div class="warning-box">
                    <p>لا يجوز استخدام علامات وصلة التجارية أو تصميماتها التجارية، بما في ذلك ضمن العلامات التجارية و/أو ضمن أسماء النطاقات، بأي شكل قد يسبب لبسًا، كما لا يجوز نسخها أو تقليدها أو استخدامها كليًا أو جزئيًا دون الحصول على إذن كتابي مسبق من وصلة.</p>
                </div>
                
                <p>يتم توفير محتوى وصلة على الموقع "كما هو" لغرض اطلاعك الشخصي واستخدامك الشخصي فقط، ولا يجوز استخدامه أو نسخه أو إعادة إنتاجه أو توزيعه أو نقله أو بثه أو عرضه أو بيعه أو ترخيصه أو استغلاله بأي شكل آخر لأي غرض آخر دون الحصول على موافقة كتابية مسبقة من المالكين المعنيين. ويُحظر أيضًا جمع البيانات أو المحتوى من الموقع بشكل منهجي لإنشاء أو تجميع، مباشرة أو غير مباشرة، مجموعة، قاعدة بيانات أو دليل دون إذن كتابي من وصلة.</p>
                <p>بشرط أن تكون مؤهلاً لاستخدام الموقع، يتم منحك ترخيصًا محدودًا للوصول إلى الموقع واستخدام محتوى وصلة، وتحميل أو طباعة نسخة من أي جزء من المحتوى الذي حصلت على حق الوصول إليه، وذلك للاستخدام الشخصي وغير التجاري فقط. تحتفظ وصلة بجميع الحقوق غير الممنوحة لك صراحةً بالنسبة للموقع ومحتوى وصلة والعلامات التجارية.</p>
                <p>إذا قمت بتحميل أو طباعة نسخة من محتوى وصلة للاستخدام الشخصي، يجب أن تحتفظ بجميع إشعارات حقوق الطبع والنشر وحقوق الملكية الأخرى الموجودة فيه. كما توافق على عدم الالتفاف على ميزات الأمان المتعلقة بالموقع، أو تعطيلها، أو التدخل فيها بأي شكل كان، أو تعطيل أي ميزات تمنع أو تحد من استخدام أو نسخ أي محتوى تابع لـ وصلة، أو تطبيق القيود المتعلقة باستخدام الموقع أو المحتوى الموجود فيه.</p>
            </div>
        </div>
        
        <!-- رخصة المساهمة -->
        <div class="section-card" id="contribution-license">
            <div class="section-title">رخصة المساهمة</div>
            <div class="section-content">
                <p>من خلال نشر مساهمات على أي جزء من موقع الويب ، فإنك تمنح تلقائيا ، وتقر وتضمن أن لديك الحق في منح تطبيقنا ترخيصا عالميا غير قابل للإلغاء ودائم وغير حصري وقابل للتحويل وخالي من حقوق الملكية ومدفوع بالكامل لاستخدام ونسخ وأداء علني وعرض علني وإعادة تنسيق وترجمة ومقتطفات (كليا أو جزئيا) وتوزيع هذه المساهمات لأي غرض ، تجاري أو إعلاني أو غير ذلك ، على موقع الويب أو فيما يتعلق به أو الترويج له ، لإعداد أعمال مشتقة من هذه المساهمات أو دمجها في أعمال أخرى ، ومنح وتفويض التراخيص الفرعية لما سبق يحق لتطبيقنا ، وفقا لتقديره الخاص والمطلق ، (1) تحرير أو تنقيح أو تغيير أي مساهمات ، (2) إعادة تصنيف أي مساهمات لوضعها في مواقع أكثر ملاءمة أو (3) الفحص المسبق أو حذف أي مساهمات يتم تحديدها على أنها غير ملائمة أو تنتهك هذه الاتفاقية</p>
            </div>
        </div>
        
        <!-- روابط من وإلى مواقع أخرى -->
        <div class="section-card" id="external-links">
            <div class="section-title">روابط من وإلى مواقع أخرى</div>
            <div class="section-content">
                <p>من باب المجاملة لك ، قد يقدم الموقع روابط لمواقع أخرى. قد تكون بعض هذه المواقع تابعة لتطبيقنا بينما البعض الآخر ليس كذلك. تطبيقنا غير مسؤول عن محتويات أي صفحات موقع ويب تم إنشاؤها وصيانةها بواسطة منظمات مستقلة عن تطبيقنا.</p>
                <p>إن زيارة أي من صفحات مواقع الويب الخاصة بجهات خارجية تكون على مسؤوليتك الخاصة. لا يتحكم تطبيقنا في صفحات مواقع الويب الخاصة بالجهات الخارجية ، ولا يمكنه ضمان دقة المعلومات أو اكتمالها أو توقيتها في صفحات مواقع الويب الخاصة بالجهات الخارجية.</p>
                <p>استخدامك لهذه المعلومات طوعي ، ويجب أن يتم اعتمادك على هذه المعلومات فقط بعد مراجعة مستقلة. لا تشكل الإشارات إلى المنتجات أو الخدمات التجارية داخل أي من صفحات مواقع الويب الخاصة بجهات خارجية أو تشير ضمنا إلى تأييد تطبيقنا. باستخدام الموقع ، فإنك تقر بأن تطبيقنا ليس مسؤولا عن توفر أو المحتوى الموجود على أو من خلال أي صفحات موقع ويب تابعة لجهات خارجية</p>
            </div>
        </div>
        
        <!-- تحديد المسؤولية -->
        <div class="section-card" id="liability-limitation">
            <div class="section-title">تحديد المسؤولية</div>
            <div class="section-content">
                <p>إلى الحد الذي يسمح به القانون ، يوفر تطبيقنا هذا الموقع والمحتوى على أساس "كما هو" و "كما هو متاح" ولا نقدم أي تعهد أو ضمان من أي نوع ، صريحا أو ضمنيا ، فيما يتعلق بمحتوى أو توفر هذا الموقع ، أو أنه سيكون في الوقت المناسب أو خاليا من الأخطاء ، أو أنه سيتم تصحيح العيوب ، أو أن الموقع أو الخادم الذي يجعله متاحا خاليا من الفيروسات أو المكونات الضارة الأخرى. وفقا للفقرة السابقة ، لا يتحمل تطبيقنا أو مديرو التطبيقات أو المسؤولون أو الوكلاء أو الموظفون أو المقاولون أي مسؤولية عن أي خسائر أو أضرار مباشرة أو غير مباشرة أو خاصة أو تبعية (بما في ذلك على سبيل المثال لا الحصر ، الأضرار الناجمة عن فقدان الأعمال أو خسارة الأرباح) ، الناشئة في العقد أو الضرر أو غير ذلك من استخدام أو عدم القدرة على استخدام هذا الموقع. لا يوجد في هذه الشروط ما يستبعد أو يحد من المسؤولية عن الوفاة أو الإصابة الشخصية الناتجة عن إهمالنا أو إهمال وكلائنا أو موظفينا.</p>
            </div>
        </div>
        
        <!-- تعويض -->
        <div class="section-card" id="indemnification">
            <div class="section-title">تعويض</div>
            <div class="section-content">
                <p>أنت توافق على تعويض تطبيقنا أو شركاته الأم أو فروعه أو الشركات التابعة له أو وكلائه أو مسؤوليه أو مديريه أو غيرهم من الموظفين وإبراء ذمتهم من أي مطالبة أو طلب أو ضرر (سواء كان مباشرا أو غير مباشر أو تبعي) ، بما في ذلك أتعاب المحاماة المعقولة ، التي يدفعها أي شخص فيما يتعلق باستخدامك للموقع ، مع عمليات الإرسال الخاصة بك ، مع أي انتهاك مزعوم للملكية الفكرية أو أي حق آخر لأي شخص أو كيان يتعلق بالموقع ، انتهاكك لشروط الاستخدام هذه ، وأي أفعال أو إغفالات أخرى تتعلق بالموقع</p>
            </div>
        </div>
        
        <!-- اخلاء المسؤوليه -->
        <div class="section-card" id="disclaimer">
            <div class="section-title">اخلاء المسؤوليه</div>
            <div class="section-content">
                <p>يتم توفير المعلومات والمحتوى والمنتجات والخدمات والمواد المتاحة من خلال الموقع (سواء تم توفيرها بواسطة تطبيقنا أو أنت أو المستخدمين الآخرين أو الشركات التابعة / الأطراف الثالثة الأخرى) ، بما في ذلك على سبيل المثال لا الحصر ، طلبات الأطعمة / المشروبات ، والتقديمات ، والنصوص ، والصور ، والرسومات ، والملفات الصوتية ، والفيديو ، والروابط ، "كما هي" و "كما هي متوفرة" دون ضمانات من أي نوع ، سواء كانت صريحة أو ضمنية. إلى أقصى حد يسمح به القانون ، يتنصل تطبيقنا من جميع الإقرارات والضمانات ، الصريحة أو الضمنية ، بما في ذلك على سبيل المثال لا الحصر ضمانات القابلية للتسويق والملاءمة لغرض معين والملكية وعدم الانتهاك والخلو من فيروسات الكمبيوتر والضمانات الضمنية الناشئة عن مسار التعامل أو مسار الأداء</p>
            </div>
        </div>
    </div>


<app-footer-style-one></app-footer-style-one>